import { th } from "intl-tel-input/i18n";

// @ts-check
export class Media {
/**
 * 
 * @param {any} main 
 * @param {any} state 
 * @param {any} parent 
 */
constructor(main,state,parent){
this.m = this.main = main;
this.state = state;
this.parent = parent;
this.singleMedia = null;
/**@type {any[]|null}*/this.media$=null;//plural or list
/**@type {any[]|null}*/this.displayMedia=null;
}
async setDisplay(){
if(!this.state.stateObject){
this.state.stateObject = await this.main.fu.fetch({
    link:this.main.fu.getApi(this.state.url)
});
}

//
if(this.state.stateObject){
this.media$ = this.displayMedia= this.state.stateObject;
if(this.state.type=='list'){
}else{

}
}//
}//func
/**
 * 
 * @param {any} data 
 * @returns 
 */
async getMediaTemplate(data={src:'',mediaType:'',save:false}){   
let $this = this;
//let iconClasz = 
let div = this.main.pbu.createElement('div',['card','media-template']);
div.innerHTML = 
`
<div class='sp-placeholder border border-secondary  m-2'>
<input class="d-none sp-input" type="file" accept="${data.mediaType}/*">
<p class="small">${await this.main.pbu.getSvg(data.mediaType)}Upload ${data.mediaType} or insert URL</p>
<button class="btn btn-sm btn-primary upload-media m-2" type="button">Upload</button>
<button class="btn btn-sm btn-primary insert-media m-2" type="button">Insert Link</button>
<i class="bi bi-trash sp-remove m-2 ${this.main.pbu.addClassIf(!data.src,['d-none'])}" style="color: #FF0000;"></i>
</div>

<div class="main-media-container text-center ${this.main.pbu.addClassIf(data.divClasz,data.divClasz)} ${this.main.pbu.addClassIf(!data.src,['d-none'])}">
</div>
`;
//handle
let input = div.querySelector('.sp-input');
let mediaDiv = div.querySelector('div.main-media-container');
let placeholdersection = div.querySelector('.sp-placeholder');
let uploadButton = div.querySelector('.upload-media');
let insertButton = div.querySelector('.insert-media');
let remove = div.querySelector('.sp-remove');

//fix, no variant
let type = (data.variant=='video')? "video/mp4":"audio/mp3" ;
if(data.src){
if(data.src.includes('youtube.com') || data.src.includes('youtu.be')){
    type =  "video/youtube";
}
this.getNewMedia(div,{src:data.src,type:type},data.mediaType,false);
}


if(data.isView || data.isWidget){
    return mediaDiv;
}else{
attachEvents();
return div;
}
async function attachEvents(){
$this.main.pbu.listen(uploadButton,'click',()=>input.click());
//
$this.main.pbu.listen(input,'change',()=>{
    $this.handleMedia(div,'upload',data.mediaType,data.save);
});
//
$this.main.pbu.listen(insertButton,'click',()=>{
$this.handleMedia(div,'insert',data.mediaType,data.save);
});

$this.main.pbu.listen(remove,'click',async ()=>{
$this.main.pbu.hide(mediaDiv,remove);
$this.main.utils.notify('Removed',{level:0});
});
}//inner
}//func
/**
 * 
 * @param {HTMLDivElement} div 
 * @param {any} source 
 * @param {string} mediaType 
 * @param {boolean} isInit 
 */
getNewMedia(div,source={src:'',type:''},mediaType,isInit){
let originalMediaSrc = div.querySelector('.main-media')?.src;
let mediaDiv = div.querySelector('div.main-media-container');
let media;
let remove = div.querySelector('.sp-remove')
if(mediaType=='image'){
mediaDiv.innerHTML = 
`
<img src ="${source.src}" class="main-media img-fluid" data-src="${source.src}" data-media-type="image"/>
`; 
media = mediaDiv.querySelector('.main-media');
}else{
    //VIDEO PLAYER
if(isInit){
        let oldMedia = div.querySelector('.main-media');
        let oldPlayer = videojs(oldMedia);
        oldPlayer?.dispose();
    }
if(mediaType == 'video'){
mediaDiv.innerHTML = `
<video-js width="640" height="264" class="main-media">
</video-js>
`;  
}else{
mediaDiv.innerHTML = `<audio class="main-media">/</audio>`;
}
  media = mediaDiv.querySelector('.main-media');
  this.main.pbu.addClass(media,["sp-video-js","video-js"]);
  media.setAttribute('data-src',source.src);
  media.setAttribute('data-media-type',mediaType);

  let option = {
 controls: true,
  autoplay: false,
  preload: 'auto',
  responsive: true,
  sources:[{ "type": source.type, "src": source.src}],
  techOrder :["html5","youtube"]
};
  videojs(media, option);
}
//finally
  this.main.pbu.show(mediaDiv,remove);
  if(originalMediaSrc?.startsWith(this.main.r2Domain)){
    media.setAttribute('originalMediaSrc',originalMediaSrc);
  }
}//func
async getListTemplate(){
await this.setDisplay();
let $this = this;
this.listTemplateSection=this.main.pbu.createElement('main',['media-component']);
this.listTemplateSection.innerHTML =
`
<section>
<div class="container">
<header>
<ul class="nav nav-tabs sp-active-list" id="myTab" role="tablist">
  <li class="nav-item" role="presentation"><button data-media-type='image' class="nav-link sp-nav-link sp-active" id="image-tab" data-bs-toggle="tab" data-bs-target="#image-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Image</button></li>
  <li class="nav-item" role="presentation"><button data-media-type='audio' class="nav-link sp-nav-link" id="audio-tab" data-bs-toggle="tab" data-bs-target="#audio-tab-pane" type="button" role="tab" aria-controls="audio-tab-pane" aria-selected="false">Audio</button></li>
  <li class="nav-item" role="presentation"><button data-media-type='video' class="nav-link sp-nav-link" id="video-tab" data-bs-toggle="tab" data-bs-target="#video-tab-pane" type="button" role="tab" aria-controls="audio-tab-pane" aria-selected="false">Video</button></li>
</ul>
<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active my-2" id="image-tab-pane" role="tabpanel" aria-labelledby="image-tab" tabindex="0"><div class="new-media my-2"></div><div class="media-list"></div></div>
  <div class="tab-pane fade show my-2" id="audio-tab-pane" role="tabpanel" aria-labelledby="audio-tab" tabindex="0"><div class="new-media my-2"></div><div class="media-list"></div></div>
  <div class="tab-pane fade show my-2" id="video-tab-pane" role="tabpanel" aria-labelledby="video-tab" tabindex="0"><div class="new-media my-2"></div><div class="media-list"></div></div>
</div>
</header>

<section class="sp-table media-list-table">
</section>
</div>

</section>
`;

await updateView();
addEvents();
return this.listTemplateSection;

async function updateView(){
$this.setListTable();
}//inner

async function addEvents(){
let tabButtons = $this.listTemplateSection.querySelectorAll('button.sp-nav-link');
for(let b of tabButtons){
    $this.main.pbu.listen(b,'click',()=>{
        $this.main.pbu.addActiveClass(b);
        $this.setListTable(b.getAttribute('data-media-type'));
    });
}
//data-media-type
}//inner
}//func

async getFormTemplate(){
let $this = this;
let m =this.singleMedia;
this.formTemplateSection= this.main.pbu.createElement('main',['media-component']);
this.formTemplateSection.innerHTML=
`
<div>
<div class="container">
<div class="row">
<div class="col-md-8 media-detail"></div>
<div class="col-md-4 media-settings">
<form>
${this.main.pbu.createFormControl({title:"Alt Text",value:m.altText,clasz:['alt-text','sp-validation-required'],serialize:true})}
${this.main.pbu.createFormControl({title:"Title",value:m.title,clasz:['title','sp-validation-required'],serialize:true})}
${this.main.pbu.createFormControl({title:"Description",value:m.title,clasz:['description','sp-validation-required'],serialize:true})}
${this.main.pbu.createFormControl({title:"Caption",value:m.caption,clasz:['caption','sp-validation-required'],serialize:true})}

<h3>Media info</h3>
<p><strong>Upload date:</strong>${m.creationDate}</p>
<p><strong>File name:</strong>${this.main.utils.getFileName(m.fileName,false)}</p>
</form>
</div>
</div>
</div>
</div>
`
;
//handle
this.mediaDetail = this.formTemplateSection.querySelector('div.media-detail');
this.mediaSettings = this.formTemplateSection.querySelector('div.media-settings');

await updateView();
addEvents();

return this.formTemplateSection;

async function updateView(){
}//inner
function addEvents(){
}//inner
}//func

async setListTable(mediaType='image'){
let $this = this;
this.state.mediaType = mediaType;
this.mediaRow = this.main.pbu.createElement('div',['row','g-5','mass-action']);
this.activeMediaTab = this.listTemplateSection.querySelector(`#${mediaType}-tab-pane`);
this.main.pbu.replace(this.activeMediaTab.querySelector('div.media-list'),this.mediaRow);
//handles
this.newMediaDiv = this.activeMediaTab.querySelector('div.new-media');
this.main.pbu.replace(this.newMediaDiv,await this.getMediaTemplate({src:'',mediaType:mediaType,save:true}),true);

let media = this.media$.filter(m=>m.mediaType==mediaType) ||[];

if(media.length>0){
for(let m of media){
let column = await this.getMediaColumn(m);
this.mediaRow.appendChild(column);
}//for
}

}//func

/**
 * 
 * @param {any} media 
 * @returns 
 */
async getMediaColumn(m){
let column = this.main.pbu.createElement('div',['col-md-2','mass-action-entry']);
column.setAttribute('data-id',m.id);
column.innerHTML = 
`
<div class="row">
<div class="col-1 flex justify-content-center align-items-center">
<input class="form-check-input mass-action-item" data-id="${m.id}" type="checkbox">
</div>
<div class="col-10 media-section" style="cursor: pointer;"></div>
</div>
`;
//handle
let input = column.querySelector('input.mass-action-item');

let src = this.main.media.getMediaUrl(m.mediaId,true,false);
let mediaTemplate = await this.getMediaTemplate({src:src,mediaType:m.mediaType,isWidget:true});
column.querySelector('.media-section').appendChild(mediaTemplate);
//event
//event to trigger deletion
this.main.dashboard.showTrashButton(input);
this.main.pbu.listen(mediaTemplate.querySelector('.main-media'),'click',async(e)=>{
this.singleMedia = m;
if(this.state.imageDiv){
let mainAttribute;
let originalMedia = this.state.imageDiv.querySelector('.main-media');
if(originalMedia){
    mainAttribute = this.m.pbu.getAttribute(originalMedia,'m');
    originalMedia.remove();
}
this.m.pbu.prependChild(this.state.imageDiv,`<img src="${src}" ${this.m.pbu.setAttributeIf(mainAttribute,[{n:"m",v: mainAttribute}])} class="main-media card-img-top" />`);

if(this.state.withDelete){
    this.main.pbu.getEventButton('Delete',{size:'sm',icon:'trash',cb:()=>{
        this.state.imageDiv.querySelector('.main-media').remove();
        this.state.imageDiv.querySelector('div.delete-media').innerHTML='';
    }}).then(r=>this.main.pbu.replace(this.state.imageDiv.querySelector('div.delete-media'),r,true));
}
this.m.modal?.close();

}else{
let formTemplate = await this.getFormTemplate();
this.main.pbu.appendChild(formTemplate.querySelector('div.media-detail'),mediaTemplate.cloneNode(true));
this.m.modal = this.main.utils.setModal(m.mediaType,formTemplate,false,{clasz:['modal-xl'],cb:()=>{
    m.title = formTemplate.querySelector('input.title').value;
    m.altText = formTemplate.querySelector('input.alt-text').value;
    m.description = formTemplate.querySelector('input.description').value;
    m.caption = formTemplate.querySelector('input.caption').value;
    this.save(m);
}});
}
});
return column;
}//func
/**
 * 
 * @param {HTMLDivElement} div 
 * @param {string} type 
 * @param {string} mediaType 
 * @param {boolean} save 
 * @returns 
 */
async handleMedia(div,type='upload',mediaType,save){
let $this=this;
let src;
let input = div.querySelector('.sp-input');
let media = div.querySelector('.main-media');
let isInit = (media)?true:false;
switch(type){
    case 'upload':
    const file = input.files[0];
if (file) {
//validate file, eg size, type
if(!file.type.startsWith(mediaType)){
    this.main.utils.notify('Wrong file type uploaded',{level:1});
    return;
}
//read file and preview;
const reader = new FileReader();
reader.onload = async function(e) {
src = e.target.result;
$this.main.log(file,'Media.handleMedia(): file');
if(src){
$this.getNewMedia(div,{src:src,type:file.type},mediaType,isInit);
if(save){
$this.save(null,true);
}

}else{
$this.main.pbu.hide(template.mediaDiv,template.remove);
}
}
reader.readAsDataURL(file);
}
    break;
    case 'insert':
let modal = this.main.utils.setModal(`Insert ${mediaType} link`,null);
//
this.main.pbu.listen(modal.confirm,'click',async()=>{
//check image source
src = modal.input.value;
if(!src){
    this.main.utils.notify(`No ${mediaType} link inserted`,{level:2,customMessageDiv:modal.notice});
    return;
}
//note: user may add wrong link for media type eg video link for image
//additional validation is required
let acceptedImageUrl = src.includes('youtube.com') || src.includes('youtu.be') || src.startsWith(this.main.r2Domain);
if(!acceptedImageUrl){
    this.main.utils.notify('Link not supported',{level:2,customMessageDiv:modal.notice});
    return;
}
modal.input.type='url';
if(!this.main.vu.validate(modal.input)){return;}
    let type = "";
   if(src.includes('youtube.com') || src.includes('youtu.be')){
    type =  "video/youtube";
}else{
    type = `${mediaType}/${src.substring().lastIndexOf('.')}`;
}
$this.getNewMedia(div,{src:src,type:type},mediaType,isInit);
if(save){
    $this.save(null,true);
}
//now
modal.dismiss.click();
});
        break;
}
//finally

async function save(){
let mediaId = await this.main.media.uploadToServer(this.activeMediaTab.querySelector('div.media-template'));
let media = this.getNew();
media.mediaId = mediaId;
media.mediaType = mediaType;

    let savedMedia = await $this.save(media);
    if(savedMedia){
        $this.media$.unshift(savedMedia);
        $this.setItems($this.media$);
        let column = await this.getMediaColumn(savedMedia);
        this.main.pbu.prependChild(this.mediaRow,column);
        this.newMediaDiv.innerHTML = '';
    }

}//inner
}//func

/**
 * 
 * @param {HTMLDivElement} div - the main container:placeholder,input etc
 */
async uploadToServer(div){
try{
let mediaId, mediaUrl,mediaType,originalFileName
let media = div.querySelector('.main-media');
if(! media){
    return '';
}
mediaType = this.main.pbu.getAttribute(media,"data-media-type");
let input = div.querySelector('.sp-input');
let src = this.main.pbu.getAttribute(media,'data-src');
if(!src){
    mediaId = '';
    mediaUrl = '';
}else if(src.startsWith(this.main.r2Domain)){
    mediaUrl = src;
    mediaId = this.getMediaUrl(src,false);
}else if(src.includes('youtube.com') || src.includes('youtu.be')){
    mediaId = '';
    mediaUrl = src;
}else if(src.startsWith('data:')){
//firstly, get upload link
let file = input.files[0];
let contentType = file.type;
originalFileName = this.main.utils.getFileName(file.name,true);
let data = {
"fileName":this.main.utils.sanitizeTitle(file.name),
"mediaType":mediaType,
"contentType":contentType
};
let bucketKey,link;
let r = await this.main.fu.fetch({
    link:this.main.fu.getApi('app/presignurl'),
    body:JSON.stringify(data)
});
this.main.log(r,`MediaHandler.uploadToServer(): cloudflare upload link`);
if(r){
bucketKey = r[0];
link = r[1];
//now we have the link, upload
let data = {
link:link,
body:file,
method:"PUT",
contentType:contentType,
noResponse:true
};
r = await this.main.fu.fetchExt(data);
if(r==true){
    this.main.log(r,`MediaHandler.uploadToServer(): cloudflare upload response`);
    mediaId = bucketKey;
    mediaUrl = src = this.getMediaUrl(mediaId,true);
    this.getNewMedia(div,{"src":src,type:contentType},mediaType,true);
}else{
    this.main.utils.notify('Error uploading image',{level:2});
    throw new Error();
}
}
}
return {
mediaId:mediaId, 
mediaUrl:mediaUrl,
mediaType:mediaType,
originalFileName:originalFileName
};
}catch(error){
this.main.utils.notify('Error uploading media',{level:2});
this.main.log(error,'MediaHandler.uploadToServert(): fetch error');
throw new Error();
}
}//func

/**
 * 
 * @param {string} mediaId 
 * @param {boolean} withDomain - if to return the id with the domain name
 * @param {boolean} showPlaceholder - if to return the placeholder for images if no url
 * @returns 
 */
getMediaUrl(mediaId,withDomain=true,showPlaceholder=true){
let url = '';
if(withDomain){
//here mediaId is the bucketKey
if(mediaId){
url = `${this.main.r2Domain}/${mediaId}`;
}else{
if(showPlaceholder){
    url = this.main.config.DEFAULT_PLACEHOLDER;
}
}
}else{
//here media is eg: https://r2.senplat.com/tenant/godlysensation/image/2026/7/1/sp-8a5a4cf9pic.png
url = mediaId.split(`${this.main.r2Domain}/`)[1];
}
return url;
}//func

/**
 * 
 * @param {any} media 
 * @param {boolean} updateMedia 
 * @returns 
 */
async save(media=null,updateMedia=false){
if(!media){
let mr = await this.main.media.uploadToServer(this.activeMediaTab.querySelector('div.media-template'));
media = this.getNew();
media.mediaId = mr.mediaId;
media.mediaUrl = mr.mediaUrl;
media.mediaType =mr.mediaType;
media.fileName = mr.originalFileName;
}
this.main.setTenant(media);
this.main.log(media,'Media.save(): Before submit');
//link is currently simulated
let r = await this.main.fu.fetch({
link:this.main.fu.getApi(`/app/media/${this.state.mediaType}/new/-1`),
body:JSON.stringify(media)
});
if(r>0){
    media.id = r;
    if(updateMedia){
        this.media$.unshift(media);
        this.setItems(this.media$);
        let column = await this.getMediaColumn(media);
        this.main.pbu.prependChild(this.mediaRow,column);
        this.main.pbu.replace(this.newMediaDiv,await this.getMediaTemplate({src:'',mediaType:media.mediaType,save:true}),true);
    }
    this.main.utils.notify('Saved',{level:0,customMessageDiv:this.m.modal?.notice});
}
this.main.utils.finilizeSave(this);
return media;
}//func

getNew(){
return {
id : -1,
fileName:"",
title:"",
description:"",
caption:"",
altText:"",
mediaId:"",
mediaUrl:"",
mediaType:"",

creationDate:"",
lastUpdate:"",
username:"",
tenantId:-1,
tenantUuid:""
};
}//func

getItems(){
    return this.media$;
}//func
/**
 * 
 * @param {any} items 
 */
async setItems(items){
this.state.stateObject = items;
await this.setDisplay();
}//func

/**
 * 
 * @param {string} mediaType 
 * @param {HTMLElement} mediaDiv 
 * @param {any} options 
 * @returns 
 */
async getMediaTrigger(mediaType,mediaDiv,options={}){
let {title = mediaType,size='md',color='primary',clasz=[],src=''} = options;
let div = this.main.pbu.createElement('div');
div.innerHTML = 
`
<button class="featured-image btn btn-${size} btn-${color}">${await this.main.pbu.getSvg(mediaType)}${title}</button>
`;
let button = div.querySelector('button');
//initial delete button if there is image
let originalMedia = mediaDiv.querySelector('.main-media');
if(originalMedia?.src && !this.main.isView){
this.main.pbu.getEventButton('Delete',{size:'sm',icon:'trash',cb:()=>{
        originalMedia?.remove();
        mediaDiv.querySelector('div.delete-media').innerHTML='';
    }}).then(r=>this.main.pbu.replace(mediaDiv.querySelector('div.delete-media'),r,true));
}

this.main.pbu.listen(button,'click',async(e)=>{
e.preventDefault();
this.state = this.main.getState('/app/media/image/list/0',false);
this.state.imageDiv=mediaDiv,
this.state.withDelete=true;
this.m.modal = this.main.utils.setModal(mediaType,await this.getListTemplate(),false,{clasz:['modal-xl']});
});
return button;
}//func

}//class
